export class ScheduleMessage {
    message: string;
    time: Date;
}

export class ScheduleItem {
    jobScheduleId: number;
    scheduleType: string;
    jobType: string;
    isCompleted: boolean;
    scheduleTime: Date;
    messages: ScheduleMessage[];
}

export class GetSchedulesResult {
    success: boolean;
    error: string;
    schedules: ScheduleItem[];
}

export class ScheduleJobDetail {
    jobType: number;
    jobName: string;
    shortName: string;
}

export class AddScheduleRequest {
    jobType: string;
    scheduleType: string;
    scheduleTime: string;
}

export const SCHEDULE_TYPES: string[] = ['None', 'Daily', 'Weekly', 'Monthly'];
